<label [attr.for]="forId" [ngClass]="labelClass">
  {{ text }} <span *ngIf="required" class="required">*</span>
</label>
